import type { Tenant, TenantListResponse, ReindexResponse } from '../types/tenants';
import type { User, UsersListResponse } from 'vince-core/types/users';
import { APIClient } from 'vince-core/api/apiClient';
import { getBaseUrl } from 'vince-core/utils/env';

const baseUrl = `${getBaseUrl('/v1/sysadmin')}/tenants`;

export async function loadTenants () {
    const allTenants: Tenant[] = [];
    let startKey: string | undefined;

    do {
        const params = new URLSearchParams({ limit: '500' });
        if (startKey) {
            params.append('startKey', startKey);
        }
        const response = await APIClient<TenantListResponse>(`${baseUrl}?${params.toString()}`);
        allTenants.push(...response.items);
        startKey = response.lastKey;
    } while (startKey);

    return { items: allTenants };
}

export async function getTenantById (tenantId: string) {
    return await APIClient<Tenant>(`${baseUrl}/${tenantId}`);
}

export async function saveTenant (data: Partial<Tenant>) {
    return await APIClient<Tenant>(`${baseUrl}`, { method: 'POST', body: JSON.stringify(data) });
}

export async function updateTenant (data: Partial<Tenant>) {
    // Remove systemStatus before sending the update request as it's a read-only field managed by the system
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { systemStatus, ...body } = data;
    return await APIClient<Tenant>(`${baseUrl}/${data.tenantId}`, { method: 'PATCH', body: JSON.stringify(body) });
}

export async function getUsersByTenantId (tenantId: string) {
    const allUsers: User[] = [];
    let startKey: string | undefined;

    do {
        const params = new URLSearchParams({ limit: '500' });
        if (startKey) {
            params.append('startKey', startKey);
        }
        const response = await APIClient<UsersListResponse>(`${baseUrl}/${tenantId}/users?${params.toString()}`);
        allUsers.push(...response.items);
        startKey = response.lastKey;
    } while (startKey);
    
    return { items: allUsers };
}

export async function updateTenantUserGroup (data: Partial<User>, tenantId: string, userId: string) {
    return await APIClient<User>(`${baseUrl}/${tenantId}/users/${userId}`, { method: 'PATCH', body: JSON.stringify(data) });
}

export async function reindexEntities (tenantId: string, entityName: string) {
    return await APIClient<ReindexResponse>(`${baseUrl}/${tenantId}/reindex-entity/${entityName}`, { method: 'POST' });
}
